import React from 'react';
import { Button } from '../ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle
} from '../ui/dialog';
import { Campaign } from '../../types';

export interface DeleteCampaignDialogProps {
  open: boolean;
  campaign: Campaign | null;
  deleting: boolean;
  error: string | null;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  onCancel: () => void;
}

export function DeleteCampaignDialog({
  open,
  campaign,
  deleting,
  error,
  onOpenChange,
  onConfirm,
  onCancel
}: DeleteCampaignDialogProps) {
  return (
    <Dialog open={open} onOpenChange={(openState) => {
      if (!deleting) {
        onOpenChange(openState);
        if (!openState) {
          onCancel();
        }
      }
    }}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="text-red-600">Excluir Campanha</DialogTitle>
          <DialogDescription>
            Tem certeza que deseja excluir a campanha <strong>"{campaign?.name}"</strong>?
            <br />
            <span className="text-red-500">Esta acao nao pode ser desfeita.</span>
          </DialogDescription>
        </DialogHeader>

        {error && (
          <div className="rounded-lg border border-red-200 bg-red-50 dark:bg-red-900/20 dark:border-red-800 p-3">
            <p className="text-sm text-red-600 dark:text-red-400">{error}</p>
          </div>
        )}

        <DialogFooter>
          <Button
            variant="outline"
            onClick={onCancel}
            disabled={deleting}
          >
            Cancelar
          </Button>
          <Button
            variant="destructive"
            onClick={onConfirm}
            disabled={deleting}
          >
            {deleting ? 'Excluindo...' : 'Excluir'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
